import * as Routes from 'constants/Routes'
import { injectReducer } from 'common/reducers'

const createSystemPanelRoute = store => ({
  path: `${Routes.SYSTEM}/:id`,
  getComponent: async function (nextState, cb) {
    const [module, reducer] = await Promise.all([
      import('./containers/SystemPanelContainer'),
      import('./reducers')
    ])

    injectReducer(store, { key: 'systemPanel', reducer: reducer.default })

    cb(null, module.default)
  }
})

export default createSystemPanelRoute
